// Web stub for @stripe/stripe-react-native (native-only; no-ops on web)
const Noop = () => null;
const asyncNoop = async () => ({});
export const StripeProvider = ({ children }) => (children ?? null);
export const CardField = Noop;
export const CardForm = Noop;
export const AddToWalletButton = Noop;
export const ApplePayButton = Noop;
export const GooglePayButton = Noop;
export const useStripe = () => ({ confirmPayment: asyncNoop, createPaymentMethod: asyncNoop, initPaymentSheet: asyncNoop, presentPaymentSheet: asyncNoop, confirmSetupIntent: asyncNoop });
export const useConfirmPayment = () => ({ confirmPayment: asyncNoop, loading: false });
export const usePaymentSheet = () => ({ initPaymentSheet: asyncNoop, presentPaymentSheet: asyncNoop, loading: false });
export const initStripe = () => {};
export const confirmPayment = asyncNoop;
export const createPaymentMethod = asyncNoop;
export default {};
